import React from "react";
import { Redirect, Route } from "react-router-dom";
import route from "./route";
import { withAppBar } from "../components/PrimaryAppBar";

const PrivateRoute = ({ component, ...rest }) => {
  const checkAuth = () => {
    return !!localStorage.getItem("accesstoken");
  };

  return (
    <Route
      {...rest}
      render={(routeProps) => {
        if (!checkAuth()) {
          return <Redirect to={route.login} />;
        }
        if (rest.path === "/" || rest.path === "/login") {
          return <Redirect to={route.productlist} />;
        }
        const WrappedComponent = (props) => withAppBar(component, props);
        return <WrappedComponent {...routeProps} />;
      }}
    />
  );
};

export default PrivateRoute;
